export default "__VITE_ASSET__bd604d38__"